module.exports = __webpack_public_path__ + "static/media/acougue.fabefb34.svg";